import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/admin/forgot-password/page.tsx");
